<div class="card p-3">
  <div class="row">
    <div class="col-12 text-primary font-weight-bold mb-1 h6">
      {{ "DATA_STUDIO.DATA_PARAMETERS.TITLE" | translate }}
    </div>
    <div class="col-12 text-primary mb-4">
      <span>{{ "DATA_STUDIO.DATA_PARAMETERS.TURBINE_LOGS" | translate }}</span>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <div class="data-assets-container">
      <div class="col-12 text-primary font-weight-bold mb-2">
        {{ "DATA_STUDIO.DATA_PARAMETERS.DATA_ASSET" | translate }}
      </div>
      <!--Date Range -->
      <div class="col-12 mb-3">
        <div class="d-flex justify-content-between">
          <span class="text-grey">{{ "DATA_STUDIO.DATA_PARAMETERS.DATE_RANGE" | translate }}</span>
          @if (wrongDate) {
            <i
              class="far fa-info-circle text-danger"
              [matTooltip]="'DATA_STUDIO.DATA_PARAMETERS.CORRECT_DATE' | translate">
            </i>
          }
        </div>
        <div class="">
          <input
            type="text"
            class="form-control date-range-picker"
            name="date-data-studio"
            #drp="bsDaterangepicker"
            bsDaterangepicker
            [bsConfig]="bsConfig | async"
            [(ngModel)]="bsRangeValue"
            [maxDate]="maxDate"
            [minDate]="minDate"
            (bsValueChange)="changeDateRange($event)"
            [class.border-danger]="wrongDate"
            placement="bottom left"
            />
        </div>
      </div>
      <!--Aggregation Method -->
      <div class="col-12 mb-3">
        <div class="d-flex justify-content-between">
          <span class="text-grey">{{"DATA_STUDIO.DATA_PARAMETERS.AGGREGATION_METHOD" | translate}}</span>
        </div>
        <lib-select
          id="data-turbine-log-select-aggregation"
          [options]="aggregationOptions.titles"
          [label]="selectedAggregationName"
          [border]="'custom-border'"
          [classes]="'font-size-normal-small text-primary h-100'"
          [notBold]="true"
          [fullWidth]="true"
          [itemClasses]="'font-size-normal-small'"
          [container]="''"
          (selectedChanged)="selectAggregation($event)">
        </lib-select>
      </div>
      <!--Turbine Type -->
      @if (selectedAggregation === 'turbine_type') {
        <div class="col-12 mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{ "DATA_STUDIO.DATA_PARAMETERS.TURBINE_TYPE" | translate }}</span>
          </div>
          <lib-select
            id="data-turbine-log-select-turbine-type"
            [options]="turbineTypes"
            [label]="turbineTypeSelection"
            [border]="'custom-border'"
            [classes]="'font-size-normal-small text-primary h-100'"
            [notBold]="true"
            [fullWidth]="true"
            [itemClasses]="'font-size-normal-small'"
            [doNotTranslate]="true"
            [container]="''"
            (selectedChanged)="selectTurbineType($event)">
          </lib-select>
        </div>
      }
      <!--Select Park -->
      @if (selectedAggregation === 'park' || selectedAggregation === 'turbine') {
        <div
          class="col-12 mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{ "DATA_STUDIO.DATA_PARAMETERS.SELECT_PARK" | translate }}</span>
          </div>
          @if (dataParks) {
            <lib-select
              id="data-turbine-log-select-park"
              [options]="dataParksNames"
              [label]="parkSelected?.fe_name"
              [border]="'custom-border'"
              [classes]="'font-size-normal-small text-primary h-100'"
              [notBold]="true"
              [fullWidth]="true"
              [itemClasses]="'font-size-normal-small'"
              [doNotTranslate]="true"
              [container]="''"
              (selectedChanged)="selectPark($event)">
            </lib-select>
          }
        </div>
      }
      <!--Select Turbines -->
      @if (selectedAggregation === 'park' && parkSelected) {
        <div
          class="col-12 mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{ "DATA_STUDIO.DATA_PARAMETERS.SELECT_TURBINES" | translate }}</span>
          </div>
          <app-data-assets
            [park]="parkSelected"
            [aggregationMethod]="'park'"
            (selectedParksTurbines)="selectedAssetTurbines($event)">
          </app-data-assets>
        </div>
      }
      <!--Select One Turbine -->
      @if (selectedAggregation === 'turbine') {
        <div class="col-12 mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{ "DATA_STUDIO.DATA_PARAMETERS.SELECT_TURBINE" | translate }}</span>
          </div>
          <lib-select
            id="data-turbine-log-select-one-turbine"
            [options]="turbinesList"
            [label]="turbineSelection"
            [border]="'custom-border'"
            [classes]="'font-size-normal-small text-primary h-100'"
            [notBold]="true"
            [fullWidth]="true"
            [itemClasses]="'font-size-normal-small'"
            [doNotTranslate]="true"
            [container]="''"
            (selectedChanged)="selectedOneTurbine($event)">
          </lib-select>
        </div>
      }
      <!--Select Assets -->
      @if (selectedAggregation === 'turbine_type' && turbineType) {
        <div
          class="col-12 mb-3">
          <div class="d-flex justify-content-between">
            <span class="text-grey">{{ "DATA_STUDIO.DATA_PARAMETERS.SELECT_ASSETS" | translate }}</span>
          </div>
          <div class="d-flex select-assets-container justify-content-between mb-2">
            <div class="w-100 mr-2">
              @if (dataParks) {
                <lib-select
                  id="data-turbine-log-select-park"
                  [options]="assetParksNames"
                  [label]="parkNameSelected || ('DATA_STUDIO.DATA_PARAMETERS.SELECT_PARK_TO_ADD' | translate)"
                  [border]="'custom-border'"
                  [classes]="'font-size-normal-small text-primary h-100'"
                  [notBold]="true"
                  [fullWidth]="true"
                  [itemClasses]="'font-size-normal-small'"
                  [doNotTranslate]="true"
                  [container]="''"
                  (selectedChanged)="selectParkAsset($event)">
                </lib-select>
              }
            </div>
            <lib-button
              id="data-turbine-log-btn-add-park"
              [disabled]="!parkNameSelected"
              [label]="'DATA_STUDIO.DATA_PARAMETERS.ADD_PARK' |translate"
              (buttonClicked)="addPark()" >
            </lib-button>
          </div>
          @if (assetParkTurbinesSelected.length > 0) {
            <div class="row">
              @for (parkItem of assetParkTurbinesSelected; track $index) {
                <div
                  class="col-12"
                  >
                  <app-data-assets
                    [park]="parkItem"
                    (selectedParksTurbines)="selectedAssetTurbines($event)"
                    (removeParkList)="removeParkList($event)">
                  </app-data-assets>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
    @if (signalGroupArray.length > 0) {
      <div
        class="d-flex flex-column available-signals-container">
        <div class="text-primary font-weight-bold mb-2">
          {{ "DATA_STUDIO.DATA_PARAMETERS.AVAILABLE_SIGNALS" | translate }}
        </div>
        @for (signalGroup of signalGroupArray; track $index) {
          <div
            class="border rounded w-100 p-2 mb-3 text-primary">
            <div class="d-flex justify-content-between">
              <mat-checkbox
                [(ngModel)]="signalGroup.signalGroupName.checked"
                (change)="selectAllSignalsByGroup(signalGroup.signalGroupName.name)">
                <b>{{ signalGroup.signalGroupName.name | translate | titlecase }}</b></mat-checkbox>
                <span>
                  <small>
                    {{ tLogSignalGroupSelected }} {{ "COMMON.OF" | translate }}
                    {{ signalGroup.signals.length }}
                  </small>
                </span>
              </div>
              <div>
                <hr class="my-1" />
              </div>
              <div class="row">
                @for (signals of signalGroup.signals; track $index; let i = $index) {
                  <div
                    class="col-4 pr-2">
                    <mat-checkbox
                      [(ngModel)]="signals.checked"
                      [value]="signals.value"
                      (change)="checkSelectedSignals()">
                      <span [appCustomTooltip]="tooltipTemplate">{{ signals.name | translate }}</span>
                    </mat-checkbox>
                    <ng-template #tooltipTemplate>
                      <div>
                        <b>{{ signals.name | translate }}</b
                          ><br />
                          {{ signals.value }}
                          <hr class="my-1" />
                          {{ signals.description | translate }}<br />
                        </div>
                      </ng-template>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
